<template>
  <crud-modal
    :title="$t('modals.company.deleteSenderTitle')"
    action="delete"
    :on-submit="submit"
    :on-close="() => $emit('close')"
  >
    <div class="mb-6">
      {{ $t('modals.company.deleteSenderTextPrefix') }} <span class="font-semibold">{{ email }}</span> {{ $t('modals.company.deleteSenderTextSuffix') }}
    </div>
    <div
      v-if="isDefault"
      class="text-red-600 font-bold my-2"
    >
      {{ $t('modals.company.deleteSenderWarning') }}
    </div>
    <div class="flex mb-2">
      {{ $t('modals.company.deleteSenderInfo') }}
    </div>
  </crud-modal>
</template>

<script>
import DELETE_HOPPERMATION_SENDER from '@/graphql/emailVerification/DeleteHoppermationSender.gql'
import CrudModal from '@/components/modals/crud-modal'
import eventBus, { eventNames } from '@/lib/eventBus'

export default {
  components: { CrudModal },
  props: {
    senderId: {
      type: String,
      required: true
    },
    email: {
      type: String,
      default: ''
    },
    isDefault: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async submit () {
      try {
        await this.$apollo.mutate({
          mutation: DELETE_HOPPERMATION_SENDER,
          variables: { input: { senderId: this.senderId } },
          refetchQueries: ['HOPPERMATION_SENDERS']
        })
      } catch (err) {
        eventBus.$emit(eventNames.SHOW_SNACKBAR, { type: 'error', text: this.$t('modals.company.deleteSenderError') })
      }
    }
  }
}
</script>
